export type TimezoneOption = {
  label: string;
  shortLabel: string;
  value: string;
};

export const TIMEZONE_OPTIONS: TimezoneOption[] = [
  {
    label: 'Atlantic Time (Puerto Rico)',
    shortLabel: 'AST',
    value: 'America/Puerto_Rico',
  },
  {
    label: 'Eastern Time (New York)',
    shortLabel: 'ET',
    value: 'America/New_York',
  },
  {
    label: 'Central Time (Chicago)',
    shortLabel: 'CT',
    value: 'America/Chicago',
  },
  {
    label: 'Mountain Time (Denver)',
    shortLabel: 'MT',
    value: 'America/Denver',
  },
  {
    label: 'Mountain Standard Time (Phoenix)',
    shortLabel: 'MST',
    value: 'America/Phoenix',
  },
  {
    label: 'Pacific Time (Los Angeles)',
    shortLabel: 'PT',
    value: 'America/Los_Angeles',
  },
  {
    label: 'Alaskan Time (Anchorage)',
    shortLabel: 'AKST',
    value: 'America/Anchorage',
  },
  {
    label: 'Hawaii-Aleutian Time (Honolulu)',
    shortLabel: 'HST',
    value: 'Pacific/Honolulu',
  },
];

export const US_TIMEZONES = TIMEZONE_OPTIONS;
export const TIMEZONE_SELECT_OPTIONS = TIMEZONE_OPTIONS.map(({ label, shortLabel }) => ({
  label,
  value: shortLabel,
}));

const TIMEZONE_STORAGE_KEY = 'app-selected-timezone';
const DEFAULT_TIMEZONE =
  TIMEZONE_OPTIONS.find((timezone) => timezone.value === 'America/New_York') || TIMEZONE_OPTIONS[0];

const findTimezone = (candidate?: Partial<TimezoneOption> | null): TimezoneOption | undefined => {
  if (!candidate) {
    return undefined;
  }

  return TIMEZONE_OPTIONS.find(
    (timezone) =>
      timezone.value === candidate.value ||
      timezone.shortLabel === candidate.shortLabel ||
      timezone.shortLabel === candidate.value ||
      timezone.label === candidate.label ||
      timezone.label === candidate.value
  );
};

export const getSelectedTimezone = (): TimezoneOption => {
  if (typeof window === 'undefined') return DEFAULT_TIMEZONE;

  try {
    const stored = localStorage.getItem(TIMEZONE_STORAGE_KEY);
    if (!stored) {
      return DEFAULT_TIMEZONE;
    }

    const parsed = JSON.parse(stored) as Partial<TimezoneOption>;
    return findTimezone(parsed) || DEFAULT_TIMEZONE;
  } catch {
    return DEFAULT_TIMEZONE;
  }
};

export const setSelectedTimezone = (timezone: TimezoneOption): void => {
  if (typeof window === 'undefined') return;

  try {
    localStorage.setItem(TIMEZONE_STORAGE_KEY, JSON.stringify(timezone));
  } catch {
    // Silently fail to avoid breaking the app
  }
};